import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import AppRoutes from "./AppRoutes";
import "./App.css";
import { fetchUser } from "./actions/auth";
import history from "./history";
import ErrorBoundary from "./ErrorBoundary";
import { Toaster } from "sonner";
import "styles/patterns.css";

class App extends Component {
    componentDidMount() {
        this.props.fetchUser();
    }
    render() {
        return (
            <ErrorBoundary>
                <BrowserRouter history={history}>
                    <Helmet>
                        <title>Launch Hero FYI</title>
                        <meta
                            name="description"
                            content="Launch Hero FYI is a platform for letting you know about the latest and greatest products in the market."
                        />
                        <meta
                            name="keywords"
                            content="Launch Hero, Launch Hero FYI, AI Tools, Image Generation, Image Editing, Brand Assets, Merchandise Design, Product Mockups, Digital Marketing, Content Creation, AI Solutions, Business Tools, Creative Suite, Design Platform, Marketing Tools"
                        />
                    </Helmet>
                    <Toaster position="top-center" richColors />
                    <AppRoutes currentUser={this.props.userAuth} />
                </BrowserRouter>
            </ErrorBoundary>
        );
    }
}

function mapStateToProps(state) {
    console.log("state in app: ", state);
    return {
        userAuth: state.auth?.userAuth,
    };
}

export default connect(mapStateToProps, { fetchUser })(App);
